module.exports = __webpack_public_path__ + "img/65.1ae87850.jpg";